import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./validation/vee-validate"
import "./validation/message"
import "./validation/custom-rules"
import i18n from "./i18n"

import "./assets/styles/scss/bootstrap-custom.scss"
import "./assets/styles/scss/font.scss"
import "bootstrap-icons/font/bootstrap-icons.css"

const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)

const vm = app.mount("#app")

export default vm
